import { useMemo } from 'react';

import { useShopProvider } from '#provider/useShopProvider.js';

type WithConsolidatedCheckoutProps = {
  children: React.ReactNode;
  /** If false, the component will be visible if the consolidated checkout is not enabled */
  visibleOnFalse?: boolean;
};

/** Renders the children if the consolidated checkout is enabled, alternatively if visibleOnFalse is true, it will render the children if the consolidated checkout is not enabled */
const WithConsolidatedCheckout = ({
  children,
  visibleOnFalse = false,
}: WithConsolidatedCheckoutProps) => {
  const { isConsolidatedCheckoutEnabled: isEnabled } = useShopProvider();
  /**
   * Determines if the children should be visible based on the consolidated checkout feature flag and the visibleOnFalse prop
   */
  const isChildrenVisible = useMemo(() => {
    switch (true) {
      // if the features is enabled and show on false is true, do not allow the children to be visible
      case isEnabled && visibleOnFalse:
        return false;
      // if the features is disabled and show on false is true, allow the children to be visible
      case isEnabled === false && visibleOnFalse === true:
        return true;
      // Default to the feature flag value
      default:
        return isEnabled;
    }
  }, [isEnabled, visibleOnFalse]);

  if (isChildrenVisible) {
    return children;
  }

  return null;
};

export { WithConsolidatedCheckout };
